import {
  LOGIN_VS_SUCCESS,
  LOGIN_VS_FAIL,
  LOGOUT_VS,
  GET_INSTANCE,
  INSTANCE_ERROR,
  DELETE_INSTANCE
} from '../actions/types';

const initialState = {
  data: null,
  error: {}
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case LOGIN_VS_SUCCESS:
      return {
        ...state,
        data: payload.id
      };
    case LOGIN_VS_FAIL:
    case LOGOUT_VS:
      return {
        ...state,
        data: null,
        idInstance: null
      };
    case GET_INSTANCE:
      return {
        ...state,
        data: {
          url: payload.url,
          name: payload.name,
          port_calib_downloader: payload.port_calib_downloader
        }
      };
    case INSTANCE_ERROR:
      return {
        ...state,
        error: payload,
        data: null
      };
    case DELETE_INSTANCE:
      return {
        ...state,
        data: null,
        error: {}
      };
    default:
      return state;
  }
}
